import { CheckCircleOutlined, EditOutlined, ExclamationCircleFilled } from '@ant-design/icons'
import { Steps } from 'antd'
import { StepsProps } from 'antd/lib/steps'
import * as React from 'react'

import { CollectionProps } from '../../convention'

const { Step } = Steps
type StepStatus = 'error' | 'process' | 'wait' | 'finish'

const MissingInformationStepper: React.FC<StepsProps & CollectionProps<ILineItem>> = ({
  collection: steps,
  current,
  ...others
}) => {
  const getStatus = (item: ILineItem, stepIndex: number): StepStatus => {
    if (item.has_missing_information && stepIndex !== current) {
      return 'error'
    }

    if (stepIndex === current) {
      return 'process'
    } else {
      return 'finish'
    }
  }

  const getIcon = (status: StepStatus) => {
    switch (status) {
      case 'error':
        return <ExclamationCircleFilled />
      case 'process':
        return <EditOutlined />
      case 'finish':
        return <CheckCircleOutlined />
    }
  }

  return (
    <Steps
      type="navigation"
      current={current}
      size="small"
      className={`custom-stepper-wrapper`}
      {...others}>
      {steps.map((item, index) => {
        return (
          <Step
            status={getStatus(item, index)}
            icon={getIcon(getStatus(item, index))}
            title={item.category_segment_name}
            key={`step-${index}`}
          />
        )
      })}
    </Steps>
  )
}

export default MissingInformationStepper
